<script setup lang="ts">
import isFunction from 'lodash-es/isFunction'

const modalStore = useRouterModalStore()
const { closeRouteInModal } = modalStore
const { isModalOpen, modalComponent, modalName, modalPropList } = storeToRefs(modalStore)

/**
 * @method onCloseModal
 * @description If the relevant prop is given, we close the modal with that function.
 * Otherwise, the modal uses the same closing function as before.
 */
function onCloseModal() {
  if (isFunction(modalPropList.value?.onCloseRouterModal))
    return modalPropList.value?.onCloseRouterModal()

  closeRouteInModal()
}
</script>

<template>
  <Modal
    buttons-position="center"
    :open="isModalOpen"
    :title="modalName"
    :header-icon="modalPropList?.headerIcon"
    :header-description="modalPropList?.headerDescription"
    :size="modalPropList?.size ? modalPropList?.size : 'sm'"
    :show-footer="false"
    @close="onCloseModal"
  >
    <template #content>
      <Component :is="modalComponent" v-if="modalComponent" />
    </template>
  </Modal>
</template>
